function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "credit card/add card");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "credit-card/add-card",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "generic",
  fill: "#A3F1C7"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,3.5030508 C0,1.56836927 1.56614227,0 3.50243121,0 L80.4975688,0 C82.4319081,0 84,1.57095441 84,3.5030508 L84,52.4969492 C84,54.4316307 82.4338577,56 80.4975688,56 L3.50243121,56 C1.56809187,56 0,54.4290456 0,52.4969492 L0,3.5030508 Z",
  id: "Rectangle-Copy-4"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#63CF95",
  x: 0,
  y: 35,
  width: 84,
  height: 8
}));

var SvgBlankcard = function SvgBlankcard(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "84px",
    height: "56px",
    viewBox: "0 0 84 56",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBlankcard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/blankcard.81451e30.svg";
export { ForwardRef as ReactComponent };